import { FC } from 'react';

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  stepLabels: string[];
}

const StepIndicator: FC<StepIndicatorProps> = ({
  currentStep,
  totalSteps,
  stepLabels,
}) => {
  return (
    <div className="flex justify-center mb-6 w-full">
      <div className="flex items-start">
        {stepLabels.map((label, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;

          return (
            <div key={stepNumber} className="flex items-start">
              <div className="flex flex-col items-center">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium ${
                    isCompleted
                      ? 'bg-primary-500 text-white'
                      : isCurrent
                        ? 'bg-primary-500 text-white'
                        : 'bg-gray-200 text-gray-600'
                  }`}>
                  {isCompleted ? '✓' : stepNumber}
                </div>
                <span className="text-xs mt-1 text-gray-600 whitespace-nowrap">
                  {label}
                </span>
              </div>
              {stepNumber < totalSteps && (
                <div className="flex items-center px-6 pt-4">
                  <div
                    className={`w-16 h-0.5 ${
                      isCompleted ? 'bg-primary-500' : 'bg-gray-200'
                    }`}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StepIndicator;
